import { MenuItemType } from 'antd/es/menu/interface';
import { ESidebarMenuKey, ESidebarMenuLabel, sidebarMenuIcons } from 'common/models/commonModel';
import { EUserRole } from 'entities/User/User.models';

type MenuItemWithChildren = MenuItemType & { children?: MenuItemType[] };

export const splitMenuPath = (path: string = '') => {
  const parts = path.split('/').filter(Boolean);
  const submenuKeys = parts.slice(0, -1);
  const itemKey = parts[parts.length - 1];

  return { submenuKeys, itemKey };
};

export const validateMenuPath = (menuItems: MenuItemWithChildren[], path: string = '') => {
  let items = menuItems;
  const parts = path.split('/').filter(Boolean);

  for (const part of parts) {
    const foundMenuItem = items.find((m) => m.key === part);

    if (!foundMenuItem) {
      return false;
    }

    items = foundMenuItem.children ?? [];
  }

  return true;
};

export const getSidebarMenuItems = (collapsed: boolean, role?: string): MenuItemWithChildren[] => {
  switch (role) {
    case EUserRole.Franchisee: {
      return [
        {
          key: ESidebarMenuKey.Dashboard,
          label: collapsed ? 'DB' : ESidebarMenuLabel[ESidebarMenuKey.Dashboard],
          children: [
            {
              key: ESidebarMenuKey.TrackStoreRealTime,
              label: ESidebarMenuLabel[ESidebarMenuKey.TrackStoreRealTime],
              icon: sidebarMenuIcons[ESidebarMenuKey.TrackStoreRealTime],
            },
            {
              key: ESidebarMenuKey.MonitorSales,
              label: ESidebarMenuLabel[ESidebarMenuKey.MonitorSales],
              icon: sidebarMenuIcons[ESidebarMenuKey.MonitorSales],
            },
          ],
        },
        {
          key: ESidebarMenuKey.PurchaseOrder,
          label: collapsed ? 'PO' : ESidebarMenuLabel[ESidebarMenuKey.PurchaseOrder],
          children: [
            {
              key: ESidebarMenuKey.GeneratePO,
              label: ESidebarMenuLabel[ESidebarMenuKey.GeneratePO],
              icon: sidebarMenuIcons[ESidebarMenuKey.GeneratePO],
            },
            {
              key: ESidebarMenuKey.TrackPO,
              label: ESidebarMenuLabel[ESidebarMenuKey.TrackPO],
              icon: sidebarMenuIcons[ESidebarMenuKey.TrackPO],
            },
            {
              key: ESidebarMenuKey.ViewDeliveryHistory,
              label: ESidebarMenuLabel[ESidebarMenuKey.ViewDeliveryHistory],
              icon: sidebarMenuIcons[ESidebarMenuKey.ViewDeliveryHistory],
            },
          ],
        },
        {
          key: ESidebarMenuKey.StockReconciliation,
          label: ESidebarMenuLabel[ESidebarMenuKey.StockReconciliation],
          icon: sidebarMenuIcons[ESidebarMenuKey.StockReconciliation],
        },
      ];
    }
    default: {
      return [];
    }
  }
};
